export const FUNDAMENTALS_BACKING_MANIFEST = "/audio/fundamentals-backing/1/manifest.865508185ebe.json";
